import React, { Suspense } from 'react';
import ErrorBoundary from '../../_modules/error/error_boundary';
import { onClose } from './../rego_lookup/on_close';
import { onRegoLookupConfiguratorSubmitFactory } from './../rego_lookup/on_configurator_submit_factory';
import { onValueChangeFactory } from './../rego_lookup/on_value_change_factory';
import { onEdit } from './../rego_lookup/on_edit';
import { onSubmitShopFactory } from './../rego_lookup/on_submit_shop_factory';
import { onShowTyres } from './../rego_lookup/on_show_tyres';
import { onRetry } from './../rego_lookup/on_retry';
import { onBackClick } from './../vehicle_configurator/on_back_click';
import { onShowInfo } from './../rego_lookup/on_show_info';
import { onSelectVehicle } from './../rego_lookup/on_select_vehicle';
import { handleView } from '../handle_view';
import RegoLookupStore from '../../_flux/stores/rego_lookup_store';
import { setPostSuggestionRegoConfigurator, onRegoInputLeave, onPostcodeInputLeave } from '../../_flux/actions/rego_lookup_actions';
import LastUsedConfiguratorStore from '../../_flux/stores/last_used_configurator_store';
import RegoLookupComponent from '../../_flux/components/rego_lookup/rego_lookup';

const render = (states, options) => (
    <ErrorBoundary>
        <Suspense fallback={<div>Loading...</div>}>
            <RegoLookupComponent
                staticUrl={TYROOLA.globals.staticImagesUrl}
                state={states.state}
                isVehicleProvided={states.lastUsedConfigurator.isVehicleProvided}
                tyreOptions={states.state.tyreOptions}
                stateOptions={states.state.stateOptions}
                onClose={onClose}
                onChange={options.onValueChange}
                onSubmit={options.onSubmit}
                onSubmitShop={options.onSubmitShop}
                onEdit={onEdit}
                onBackClick={onBackClick}
                onRetry={onRetry}
                onShowTyres={onShowTyres}
                onShowInfo={onShowInfo}
                onSelectVehicle={onSelectVehicle}
                store={TYROOLA.globals.store}
                selectPostcodeSuggestion={setPostSuggestionRegoConfigurator}
                onBlurRego={onRegoInputLeave}
                onBlurPostcode={onInputLeave}
            />
        </Suspense>
    </ErrorBoundary>
);

const stores = {
    state: RegoLookupStore,
    lastUsedConfigurator: LastUsedConfiguratorStore,
};

const onInputLeave = () => {
    onPostcodeInputLeave(RegoLookupStore.getState().values.postcode);
}
const getOptions = options => ({
    ...options,
    onValueChange: onValueChangeFactory(),
    onSubmit: onRegoLookupConfiguratorSubmitFactory(),
    onSubmitShop: onSubmitShopFactory(),
});

export const init = (container, options) =>
    handleView(stores, render, getOptions(options), container);